import {
  alpha,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import theme, { responsiveFontSize } from "themes/Theme";
import { navigationData } from "./navigationData";
import { useLocation, useNavigate } from "react-router-dom";
import { Logo } from "assets/index";

interface IProps {
  showLogoutModal: () => void;
}

const Sidebar: React.FC<IProps> = ({ showLogoutModal }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const getActiveListItem = (path: string) => {
    if (pathname.includes("/dashboard/transactions/")) {
      return "/dashboard/transactions";
    }
    return path;
  };

  return (
    <Box>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        gap={1}
        sx={{ py: 1 }}
      >
        <Box component={"img"} src={Logo} sx={styles.logoIcon} />
        <Typography
          sx={{
            background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
            WebkitBackgroundClip: "text",
            color: "transparent",
            ...styles.logoText,
          }}
        >
          <span style={{ color: theme.palette.primary.main }}>ERC</span> Wallet
        </Typography>
      </Stack>

      <List sx={{ marginTop: "0.5em" }}>
        {navigationData.map((item, index) => (
          <ListItem
            disablePadding
            sx={
              getActiveListItem(pathname) === item.path
                ? styles.activeListItem
                : styles.defaultListItem
            }
            key={index}
            onClick={() => {
              if (item.label === "Logout") {
                showLogoutModal();
              } else {
                navigate(item.path);
              }
            }}
          >
            <ListItemIcon
              sx={
                getActiveListItem(pathname) === item.path
                  ? styles.activeListIconItem
                  : styles.defaultListIconItem
              }
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText sx={styles.navItemText}>{item.label}</ListItemText>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
export default Sidebar;
const styles = {
  logoText: {
    fontSize: responsiveFontSize(24),
    fontWeight: 400,
  },
  logoIcon: {
    width: 50,
    height: 50,
    objectFit: "contain",
  },
  navItemText: {
    fontSize: responsiveFontSize(16),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  activeListItem: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "1.25rem",
    marginTop: "0.5em",
    padding: "0.40em",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  defaultListItem: {
    marginTop: "0.5em",
    padding: "0.75em",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  activeListIconItem: {
    borderRadius: "0.75rem",
    width: 30,
    aspectRatio: "1/1",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 1,
  },
  defaultListIconItem: {
    width: 30,
    aspectRatio: "1/1",
    borderRadius: "0.75rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 1,
  },
};
